var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{directives:[{name:"disable-right-click",rawName:"v-disable-right-click"}],staticStyle:{"background-color":"#f8f9fa !important","overflow":"hidden"}},[_c('pwaprompt'),_c('notification-dialog'),_c('general-dialog'),_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }